import { Input, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import FormWrapper from './FormWrapper';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrencyList } from '../../../store/slices/currency-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const CurrencyForm = () => {
    const [currencyName, setCurrencyName] = useState('');

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: currencyList } = useSelector((state) => state.currency);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchCurrencyList());
    },[]);

    useEffect(() => {
        if(MODE === 'EDIT' && currencyList.length) {
            const ID = searchParams.get('id');
            const selectedCurrency = currencyList.filter((item) => item.currency_id === ID);
            setCurrencyName(selectedCurrency[0].currency_name);
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, currencyList]);

    const openNotification = ({ type, message, description }) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'currency_name': currencyName,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.currency_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/currency/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/currency-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }  
    }
    const resetHandler = () => {
        setCurrencyName('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Currency</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Currency Name:</label>
                    <Input 
                    onChange={(e) => setCurrencyName(e.target.value)} 
                    value={currencyName}
                    size='large'
                    placeholder='Currency Name' 
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default CurrencyForm;


